import { Component, OnInit } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';

import { AuthService } from 'app/services';
import { GoToGroupsDialogComponent } from '../go-to-groups-dialog/go-to-groups-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../../environments/environment';
import { UnauthorizedDialogComponent } from '../unauthorized-dialog/unauthorized-dialog.component';

@Component({
  standalone: false,
  selector: 'app-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss'],
})
export class AuthErrorComponent implements OnInit {
  _internalOnly = Boolean(JSON.parse(environment.internalOnly));
  constructor(public dialog: MatDialog, private authService: AuthService) {}
  ngOnInit() {
    if (this._internalOnly === true) {
      this.authService.user$.pipe(distinctUntilChanged()).subscribe((user) => {
        if (user && user.isCompanyManager) {
          this.dialog.open(GoToGroupsDialogComponent, {
            autoFocus: false,
            panelClass: 'no-padding-dialog',
            width: '500px',
            height: 'auto',
          });
        }
      });
    } else {
      this.authService.user$.pipe(distinctUntilChanged()).subscribe((user) => {
        if (user) {
          this.dialog.open(UnauthorizedDialogComponent, {
            disableClose: true,
            autoFocus: true,
          });
        }
        else{
          this.authService.login();
        }
      });
    }
  }
}
